import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import {commonService} from "../../service/common.service";
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-packagedata',
  templateUrl: './packagedata.component.html',
  styleUrls: ['./packagedata.component.css'],
  providers: [TestSeriesService],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide',   style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
]
})
export class PackagedataComponent implements OnInit {
  @Input() myPackageSeriesId:any;
  @Input() myPackage: any;

  typetxt:any='';
  packageList:any=[];
  totalrow:any = 0;
  notfound:any;
  isPostLoad=true;
  msg:any;
  isRemaningForum:any;
  postId:any=0;
  ngload:any;
  userData:any;
  filter:any;
  noMoreResults:any;
  isError=false;
  siteUrl = this.global.websiteUrl;
  paperList:any=[];
  streambox:any=[{id:''}];
  isMyPackage = false;
  userDatalogincheck:any;
  loggedinUserId:any=0;
  //Stype = '';
  closeResult: string;
  onlinetopperslist: any;
  topperCopy :any;
  copyurl = this.global.testseriesImageUrl;
  topRanker: any;
  topTen: any;
  totalStudends:any;
  studendRank:any;
  offlinetopperslist:any;
  constructor(private modalService: NgbModal,private testseriesservice:TestSeriesService, private router:Router, private route: ActivatedRoute, private global: Globals,private commonService:commonService) { 
    
  }

  ngOnInit() {
    this.loggedinUserId = (this.commonService.user) ? this.commonService.user.id : 0;
    this.commonService.profile.subscribe((data:any)=>{
      if(data){
      this.userDatalogincheck=data; 
      }else{
        this.userDatalogincheck={};
      } 
    });

    this.route.params.subscribe((params: Params) => {
      
      if(this.myPackageSeriesId>0){
        this.userData = this.commonService.user;
         params = {};
         params['id'] = this.myPackageSeriesId;
         this.isMyPackage = true; //console.log('ddddddddddddddddddddd');
      }else this.isMyPackage = false;

      if(params['id']){      
      this.postId = parseInt(params['id']);
      if(isNaN(this.postId)){
        this.postId=0;
      }
     // let filter={};
     // filter={limit:10};
      
      this.getPackageDetail('');  
      }
    });

    
  }


  getPackageDetail(filter){
    let obj={}
    obj['id']=this.postId; 
    if(this.userData && this.userData.id){
      obj['userId']=this.userData.id;  
    }
    obj['purchasedUserId'] = (this.userDatalogincheck) ? this.userDatalogincheck.id : 0;
    this.testseriesservice.getmainstsPaperWiselist(obj).subscribe((data:any)=>{
      
      if(data.error==0){
        this.paperList =data.results[0];
        this.ngload=false;
        this.isPostLoad=false;
        // if user try to fetch other packages;
        if(this.isMyPackage) {
          if(!this.paperList.purchased) this.router.navigate(['/']);
        }

        console.log('testpaper',this.paperList);
      }
    },
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.isPostLoad=false;
      this.msg="internal server error!";
    }) 
  }

  checklogin(plist) {
    let pid = plist.id;
    if (Object.keys(this.userDatalogincheck).length == 0) {
      this.needLogin();
      return false;
    }
    if(plist.paymentMode)
      window.open(plist.externalURL, '_blank');
    else
      this.router.navigateByUrl('/student-form-pre-payment/' + pid);
  }

  needLogin(){
    this.commonService.setLoginBox(true);        
  }

  paperUrl(tpid){
    return '../../user/mypackagedetail/'+btoa(tpid);
  }

  mytestpaperUrl(tpid){
    return '../../mypackagedetail/'+btoa(tpid);
  }
  purchasedestpaperUrl(tpid){
    return '../../user/mypackagedetail/'+btoa(tpid);
  }

  getExpireDate(lastDate){
    var date = new Date();
    var ld = new Date(lastDate);
     if(date>ld) return true ;
     else return false;
   }

   getPaperStatus(status){ //console.log('status',status);
    let st = '';
    switch(status){
      case 'Pending' : st = 'Uploaded but not Assigned to Faculty';
      break;
      case 'Assigned': st = 'Under Evaluation';
      break;
      case 'Completed': st = 'Evaluation Done & Uploaded';
      break;
      default : st = 'Not Uploaded';
    }
    return st;
   }

// add popup 
open(content,testPaperId) {
  let filter = {};
  filter['testPaperId'] = testPaperId;
  this.getPapersReportSummery(filter);
  this.modalService.open(content,{size: "lg"}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  });
} 

getPapersReportSummery(obj) {
  this.testseriesservice.getTopperReport(obj).subscribe((data: any) => {

    if (data.error == 0) {
      let toptenlist = data.results.topTen;
      this.offlinetopperslist = data.results.offlinetoppers;
      this.onlinetopperslist = data.results.onlinetoppers;

      this.topTen = this.combineArray(toptenlist, this.onlinetopperslist);
      this.topTen = this.topTen.sort(function (a, b) {
        return b.totalMarks - a.totalMarks;
      });

      this.topperCopy = data.results.toppercopy;
    
      this.notfound = false;
      this.isError = false;
      this.isPostLoad = false;
      //console.log('6666',this.studendRank,this.topTen,this.totalStudends);
    } else {
      if (data.message == "Failed to authenticate token.") {
        sessionStorage.clear();
        localStorage.clear();
        //this.router.navigate(['/']);
      } else {
        this.msg = data.message;
        this.isError = true;
      }
      this.notfound = true;
      this.isPostLoad = false;
      this.topTen = [];
    }
  }, (error: HttpErrorResponse) => {
    this.isPostLoad = false;
    this.isError = true;
    this.msg = "internal server error!";
  });
}
combineArray(array1, array2) {
  return [].concat(array1, array2);
}



}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/packagedata/packagedata.component.ts